// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/pause.js';

import { paths } from '../generated/pause';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('pause', Original, paths);
